import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { XIcon } from '@phosphor-icons/react/X';
import type { JSX, ReactEventHandler } from 'react';

import { Ellipsis } from '../Ellipsis/Ellipsis.tsx';

import { DrawerDivider } from './DrawerDivider.tsx';

export interface DrawerHeaderProps {
  children?: string | JSX.Element;
  onClose?: ReactEventHandler;
  sx?: SxProps;
  dataTest?: string;
  marginBottom?: number;
}

export function DrawerHeader(props: DrawerHeaderProps): JSX.Element {
  const { children, onClose, marginBottom = 3, dataTest, sx } = props;

  return (
    <Box
      sx={{
        marginBottom: theme => theme.spacing(marginBottom),
        ...sx,
      }}
      data-test={dataTest}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: theme => theme.spacing(1.5),
        }}
      >
        <Typography
          variant="h3"
          data-test="details-title"
          sx={{
            overflowX: 'hidden',
          }}
        >
          <Ellipsis width="100%" tooltip={true} detectTooltipResize={true}>
            {children}
          </Ellipsis>
        </Typography>
        {onClose && (
          <IconButton
            aria-label="Close drawer"
            data-test="close-drawer"
            onClick={onClose}
            sx={{
              marginLeft: theme => theme.spacing(3),
            }}
          >
            <XIcon />
          </IconButton>
        )}
      </Box>
      <DrawerDivider />
    </Box>
  );
}
